import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div`
  margin-left: 16px;
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${device.mobileMax} {
    margin-bottom: 24px;
  }
`

export const Title = styled.span`
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: 400;
  line-height: 15px;
  color: ${colors.mainText};
`

export const MatchedGenres = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: ${colors.mainText};
`
